<template>
  <div class="chavePix">
    <div v-if="loader" class="iloader row justify-center align-center">
      <Loader />
    </div>
    <div class="buttons text-center">
      <div v-if="cnpj.length" class="info">Declaro que tenho chave PIX cadastrada com o CNPJ <b>{{ cnpj | cnpj
      }}</b><br /> e estou ciente que
        os pagamentos de eventuais serviços prestados<br />serão realizados exclusivamente através <br />da chave PIX
        <b>{{ cnpj }}</b>.
      </div>
      <Button v-if="cnpj.length" :loader="load" layout="green-m" @click="pay">CONFIRMAR</Button>
      <div v-if="cnpj.length == 0 && !loader" class="error">Primeiro é necessário resolver a pendência:<br /><b>Informar documentos</b>.</div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Loader from "@/components/Loader";
import Button from "@/components/Button.vue";

export default {
  components: { Button, Loader },
  props: { modal: Object },
  data() {
    return { load: false, loader: true, cnpj: "" };
  },
  methods: {
    ...mapActions("user", ["LOAD_DOCS"]),
    ...mapActions("supporter", ["CHAVE_PIX"]),
    async pay() {
      this.load = true
      await this.CHAVE_PIX({})
      this.load = false
      this.modal.callback()
    }
  },
  beforeMount() {
    this.LOAD_DOCS(this.user.id_doutor).then(({ data }) => {
      if (data && data.pj && data.pj.cnpj) {
        this.cnpj = data.pj.cnpj
      }
      this.loader = false
    })
  },
  computed: {
    ...mapGetters("user", ["user"])
  }
}
</script>

<style lang="scss" scoped>
@use "@/assets/scss/vars.scss" as *;

.chavePix {
  color: $gray-6;
  padding: 10px 30px;
  max-width: 900px;
  border-radius: 12px;
  background: $white;

  .iloader {
    min-height: 200px;
  }

  .buttons {
    padding: 20px;

    button {
      margin-top: 30px;
      font-size: 16px;
    }
  }

  .info {
    color: $purple;
  }

  .warn,
  .error {
    color: $red-1;
    font-size: 15px;
    margin-bottom: 12px;
    font-weight: bold;
  }
}
</style>
